import React from 'react'
import { Link } from 'react-router-dom'

const FooterLink = ({text,href}) => {
  return (
    <Link className='fs-6 text-white text-decoration-none' to={href}>{text}</Link>
  )
}

export default FooterLink